import { Typography, TypographyProps } from '@mui/material';

const EmptySupportedTypography = (props: TypographyProps) => {
	const { children } = props;
	return <Typography {...props}>{children || '-'}</Typography>;
};

export default EmptySupportedTypography;
